import Papa from 'papaparse';

class CSVGenerator {
    constructor(data, cols, title) {
        this.data = data;
        this.cols = cols;
        this.title = title;
    }

  // Handle and format the report data
  handleReport() {
        let report = this.data.map((row) => {
            // Format keys for CSV
            let csvCols =  this.cols

            const formattedRow = {};

            // Rename keys according to csvCols
            for (const prop in csvCols) {
                formattedRow[csvCols[prop]] = row[prop];
            }

            return formattedRow;
        });
    return report;
  }

  // Convert the report to CSV and trigger download
  getCSV() {
    const report = this.handleReport();

    // Return CSV as a Promise
    return new Promise((resolve, reject) => {
        try {
            const csv = Papa.unparse(report);
            resolve(csv);
        } catch (error) {
            console.error('Error unparsing CSV file:', error);
            reject(error);
        }
    }).then((res) => {
        // Create a Blob from the CSV string
        const blob = new Blob([res], { type: 'text/csv' });

        // Generate a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.title}.csv`;

        // Trigger download
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
    });
  }
}

export default CSVGenerator;
